<template>
  <v-dialog
    width="700"
    v-model="showDialog"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="mr-4 mb-4"
        plain
        text
        x-large
        v-on="on"
        color="error"
      >
        <v-icon class="patient-overview__icon">mdi-account-remove</v-icon>
        {{ $ucfirst($t('patient.droppedout')) }}
      </v-btn>
    </template>

    <v-card>
      <div class="clearfix">
        <v-btn
          class="pull-right btn-transparent"
          icon
          plain
          @click="showDialog = false"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <div class="pa-5">
        <p class="d-flex justify-space-around pb-5">
          {{ $ucfirst($t('patient.markPatientAsDroppedOut', { params: {'studyID': studyId} })) }}
        </p>
        <div class="d-flex justify-space-around pb-5">
          <v-btn
            color="primary"
            outlined
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click="dropOut"
          >
            {{ $ucfirst($t('confirm')) }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            :x-large="$vuetify.breakpoint.mdAndUp"
            @click="showDialog = false"
          >
            {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
          </v-btn>
        </div>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

/**
 * Component DropOutButton.vue
 *
 * @module DropOutButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/components/Parts/DropOutButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'DropOutButton',
  props: {
    patientId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      studyId: 'patientSummary/studyId',
    }),
  },
  data() {
    return {
      showDialog: false,
    }
  },
  methods: {
    async dropOut() {
      const success = await this.$store.dispatch('patientSummary/dropOut', this.patientId);

      if (success) {
        this.$toasted.show(this.$ucfirst(this.$t('successMessages.patientMarkedAsDropped')), {
          type : 'success',
          icon : 'check',
          position: 'bottom-center',
        });
      }

      this.showDialog = false;
      this.$router.push({ name: 'Alerts' });
    },
  }
};
</script>
